import { render } from "./BaseWrapper.vue?vue&type=template&id=69dc19c8"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"

import "./BaseWrapper.vue?vue&type=style&index=0&id=69dc19c8&lang=scss"
script.render = render

export default script